function formatDashboardItemForMutation(item, shouldStringifyBody) {
  const { __typename, ...restItem } = item
  const { __typename: _headerType, ...headers } = restItem?.headers || {}
  const formattedItem = {
    ...restItem,
    headers,
  }

  if (shouldStringifyBody && item?.body) {
    formattedItem.body = JSON.stringify(item?.body)
  }

  return formattedItem
}
export default formatDashboardItemForMutation
